<template>
  <div class="std-background">
    <v-card width="500" class="mx-auto my-3">
      <div class="std-title std-title--no-bg text-center">
        <img :src="require('@/assets/booking.png')" width="75" class=" pb-2">
        <h2>Yay! {{representativeBooking ? 'She is' : 'You are'}} clear for booking</h2>
      </div>
      <div class="std__content" :class="{'ma-2 pa-3': $vuetify.breakpoint.smAndDown}">
        <p>Looks like {{representativeBooking ? 'she is' : 'you are'}} eligible for a 'Basic Bekam' therapy with Dr. Asmah! Before we confirm the booking, we would need {{representativeBooking ? 'her' : 'your'}} contact details.</p>
        <p class="primaryLight--text font-weight-bold">Please enter your contact details</p>
        <!-- START FORM -->
        <v-form v-model="valid">

          <!-- START RELATIONSHIP FIELD (FOR REPRESENTATIVE BOOK) -->
          <v-text-field v-if="representativeBooking"
            outlined dense color="primaryLight" background-color="#fff"
            type="text" v-model="booker" label="Your name">
          </v-text-field>

          <!-- START NAME FIELD -->
          <v-text-field
            outlined dense color="primaryLight" background-color="#fff"
            type="text" v-model="name" :label="(representativeBooking ? 'Her ' : '') + 'Name'" :rules="nameRules"
            :error-messages="errors.name"
            @focus="errors.name = []"
            required>
          </v-text-field>

          <v-text-field v-if="representativeBooking"
            outlined dense color="primaryLight" background-color="#fff"
            type="text" v-model="relationship" label="She is your...">
          </v-text-field>

          <!-- START CONTACT FIELD -->
          <v-text-field
            outlined dense color="primaryLight" background-color="#fff"
            type="text" v-model="number" label="Phone/Mobile Number" :rules="numberRules"
            prefix="+673"
            :error-messages="errors.contact_number"
            @focus="errors.contact_number = []"
            required>
          </v-text-field>

          <!-- START BIRTHDATE FIELD -->
          <template>
            <v-menu
              ref="datepicker"
              v-model="datepicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  background-color="#fff"
                  outlined dense color="primaryLight"
                  v-model="birthdate"
                  :label="(representativeBooking ? 'Her ' : '') + 'Birthdate'"
                  :hint="showHelp ? 'Birthday girls get special promo pricing!' : ''"
                  readonly
                  v-bind="attrs"
                  v-on="on">
                  <v-icon slot="append" color="primaryLight" @click="showHelp = !showHelp">
                    mdi-help-circle
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="birthdate"
                :max="new Date().toISOString().substr(0, 10)"
                min="1940-01-01"
                @change="setDate()"
              ></v-date-picker>
            </v-menu>
          </template>

          <!-- HOUSECALL CHECK -->
          <v-checkbox v-model="houseCall" class="mt-0" :label="`Are you booking a house call? (Dr. Asmah comes to ${representativeBooking ? 'her' : 'your'} place)`"></v-checkbox>

          <!-- START ADDRESS FIELD -->
          <v-textarea
            v-if="houseCall"
            outlined dense color="primaryLight" background-color="#fff"
            label="Address" auto-grow rows="3" v-model="address">
          </v-textarea>

          <p v-if="errors.contact_details" class="red--text">{{errors.contact_details[0]}}</p>
        </v-form>
        <!-- END FORM -->

        <div class="text-center mt-3 mb-10">
          <v-btn block depressed color="primaryLight" class="white--text"
            :loading="loading" :disabled="loading || !valid" @click="confirmBooking()">
            confirm booking
            <template v-slot:loader>
              <span>Processing...</span>
            </template>
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  import moment from 'moment'
  import bookingsCollection from '../services/firestore/booking'

  export default {
    name: 'Booking',
    data() {
      return {
        serviceNumber: 6738725714,
        representativeBooking: this.$store.state.representativeBooking,
        datepicker: false,
        valid: false,
        loading: false,
        showHelp: false,
        houseCall: false,

        // Form data
        booker: '',
        relationship: '',
        name: '',
        nameRules: [
          name => !!name || `What would ${this.representativeBooking ? 'she' : 'you'} like to be called?`
        ],
        number: '',
        numberRules: [
          number => !!number || 'Please enter a contact number so we can reach you.',
          number => number.match(new RegExp('^[0-9]+$')) || 'Please only use numbers.',
          number => number.length == 7 || 'Please enter a valid 7 digit number.'
        ],
        birthdate: '',
        address: '',
        errors: {
          name: [],
          contact_number: [],
          contact_details: []
        }
      }
    },
    watch: {
      datepicker(val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    },
    methods: {
      setDate(date) {
        this.$refs.datepicker.save(date)
      },
      async confirmBooking() {
        this.errors = {
          name: [],
          contact_number: [],
          contact_details: []
        }
        this.loading = true

        await bookingsCollection.create({
          client: {
            name: this.name,
            contact_number: this.number,
            birthdate: new Date(moment(this.birthdate).format()),
            address: this.address || 'Undisclosed'
          },
          booking: {
            details: {
              is_self_booking: !this.representativeBooking,
              booker: this.booker || 'Self',
              relationship_with_booker: this.relationship || 'Self',
              is_house_call: this.houseCall
            }
          }
        }).then(() => {
          this.loading = false
          this.$router.push('/results?status=green')
        }).catch(err => {
          this.loading = false
          err = err.response.data
          this.errors = {
            name: err.name || [], contact_number: err.contact_number || [], contact_details: err.contact_details || []
          }
        })
      }
    }
  }
</script>